import { Component, Input } from '@angular/core';

import { IBodyFooter, OnClickItem } from './body-footer.types';
import { SectionService } from 'src/app/shared/services/section.service';
import {
  NX23Link,
  NX23SocialLink,
  NX23LinkFields,
  NX23SocialLinkFields,
} from 'src/app/shared/types/content-types';

@Component({
  selector: 'nx-body-footer',
  templateUrl: './body-footer.component.html',
  styleUrls: ['./body-footer.component.scss'],
})
export class BodyFooterComponent implements IBodyFooter {
  constructor(private section: SectionService) {}

  // REQUIRED INPUT
  @Input() data!: IBodyFooter['data'];

  // METHODS

  /**
   * Returns the image source and alt text from a link
   * @param link Link element to get the image from
   * @returns An object with the image source and alt text if the link is a social link, otherwise null
   */
  getImage(link: NX23Link | NX23SocialLink): any {
    if (this.isSocialLink(link.fields)) {
      return {
        src: link.fields.icon.fields.file?.url,
        alt: link.fields.icon.fields.description,
      };
    }
    return null;
  }

  // Type guard function that helps TypeScript narrow down the type of link (a social Link or a regular Link)
  isSocialLink(
    link: NX23LinkFields | NX23SocialLinkFields,
  ): link is NX23SocialLinkFields {
    return (link as NX23SocialLinkFields).icon !== undefined;
  }
}
